// public routes
export const LoginPageRoute = "/login";
export const MainPageRoute = "/";
export const FeaturesPageRoute = "/features";
export const AcinPageRoute = "/acin";
export const ContactsPageRoute = "/contacts";
export const SubscriptionPageRoute = "/subscribe";

// PRIVATE ROUTES

// ADS
export const AdsPageRoute = "/ads";
export const AdsDrePageRoute = `${AdsPageRoute}/dre`;
export const AdsDreDetailPageRoute = `${AdsDrePageRoute}/:id`;
export const AdsFollowDetailPageRoute = `${AdsPageRoute}/:type/:id`;
export const AdsFollowEditPageRoute = `${AdsFollowDetailPageRoute}/edit`;
export const AdsEditPageRoute = `${AdsDreDetailPageRoute}/edit`;
export const AdsJoraaPageRoute = `${AdsPageRoute}/joraa`;
export const AdsJoraaDetailPageRoute = `${AdsJoraaPageRoute}/:id`;
export const AdsJoraaEditPageRoute = `${AdsJoraaDetailPageRoute}/edit`;

// Filters
export const FiltersPageRoute = "/filters";
export const FiltersNewPageRoute = `${FiltersPageRoute}/new`;
export const FilterPageRoute = `${FiltersPageRoute}/filter/:filterId`;
export const FilterEditPageRoute = `${FilterPageRoute}/edit`;

// Profile
export const ProfilePageRoute = "/profile";
export const ProfileEditPageRoute = `${ProfilePageRoute}/edit`;
export const ChangePasswordPageRouter = `${ProfilePageRoute}/change-password`;
export const ChangePasswordEditPageRouter = `${ChangePasswordPageRouter}/edit`;

// Users
export const UsersPageRoute = "/users";
export const UserAdminPageRoute = `${UsersPageRoute}/user/:userId`;
export const UserNewPageRoute = `${UsersPageRoute}/new`;
export const UserAdminEditPageRoute = `${UserAdminPageRoute}/edit`;
export const UserPageRoute = `${UsersPageRoute}/user/:userId`;
export const UserEditPageRoute = `${UserPageRoute}/edit`;

// Users Entities
export const UsersEntitiesPageRoute = "/only-users";

// Entities
export const EntitiesPageRoute = "/entities";
export const EntitiesPageNewRoute = `${EntitiesPageRoute}/new`;
export const EntityPageBaseRoute = `${EntitiesPageRoute}/entity/:entityId`;
export const EntityPageRoute = `${EntityPageBaseRoute}/details`;
export const EntityPageUserRoute = `${EntityPageBaseRoute}/details/users`;
export const EntityEditPageRoute = `${EntityPageRoute}/edit`;
export const EntityUserPageRoute = `${EntityPageBaseRoute}/users/user/:userId`;
export const EntityUserEditPageRoute = `${EntityUserPageRoute}/edit`;
export const EntityPaymentsPageRoute = `${EntityPageBaseRoute}/payments`;
export const EntityPaymentPageRoute = `${EntityPageBaseRoute}/payments/payment/:paymentId`;
export const EntityPaymentEditPageRoute = `${EntityPaymentPageRoute}/edit`;
export const EntityFilterPageRoute = `${EntityPageBaseRoute}/filters/:filterId`;
export const EntityEditFilterPageRoute = `${EntityFilterPageRoute}/edit`;
export const EntityHistoryFilterPageRoute = `${EntityFilterPageRoute}/history`;
export const EntityNewFilterPageRoute = `${EntityPageRoute}/filters/new`;
export const EntityViewPaymentInvoiceRoute = `${EntityPaymentPageRoute}/viewPaymentInvoice`;
export const EntityFinishPaymentInvoiceRoute = `${EntityPaymentPageRoute}/finishPayment`;

// Contracting Authorities
export const ContractingAuthoritiesPageRoute = "/contracting-authorities";
export const ContractingAuthorityPageRoute = `${ContractingAuthoritiesPageRoute}/contracting-authority/:id`;
export const ContractingAuthorityEditPageRoute = `${ContractingAuthorityPageRoute}/edit`;
export const ContractingAuthorityNewPageRoute = `${ContractingAuthoritiesPageRoute}/new`;

// Recommendations
export const RecommendationsPageRoute = "/recommendations";
export const NewRecommendationPageRoute = `${RecommendationsPageRoute}/new`;

// Payments
export const PaymentsPageRoute = "/payments";
export const PaymentDetailPageRoute = `${PaymentsPageRoute}/payment/:paymentId`;
export const PaymentEditPageRoute = `${PaymentDetailPageRoute}/edit`;
export const ViewPaymentInvoiceRoute = `${PaymentDetailPageRoute}/viewPaymentInvoice`;
export const FinishPaymentInvoiceRoute = `${PaymentDetailPageRoute}/finishPayment`;

// Services
export const ServicesAreaPageRoute = "/services";
export const ServicesListPageRoute = "/services/list";
export const ServicesPageRoute = `/services/service`;
export const ServicePageNewRoute = `${ServicesPageRoute}/new`;
export const ServicesDetailsPageRoute = `${ServicesPageRoute}/:serviceId/details`;
export const ServicesDetailPageRoute = `${ServicesPageRoute}/:serviceId`;
export const ServicesDetailsEditPageRoute = `${ServicesDetailsPageRoute}/edit`;
export const ServicePromotionPageRoute = `${ServicesDetailPageRoute}/promotions/promotion/:promotionId`;
export const ServicesPromotionsDetailPageRoute = `${ServicesAreaPageRoute}/promotions/promotion/:promotionId`;
export const ServicesPromotionsEditPageRoute = `${ServicesAreaPageRoute}/promotions/promotion/:promotionId/edit`;
export const ServicesDetailPromotionsDetailPageRoute = `${ServicesDetailsPageRoute}/promotions/promotion/:promotionId`;
export const ServicesPromotionsPageRoute = `${ServicesPageRoute}/promotions/promotion/:promotionId`;
export const NewGeneralPromotionPageRoute = `${ServicesListPageRoute}/promotions/new`;
export const ServicePromotionEditPageRoute = `${ServicePromotionPageRoute}/edit`;
export const PrivacyPageRoute = "/privacy";
export const SubscriptionsPageRoute =
  "/services/subscriptions/service/:serviceId";

// Alerts
export const AlertsPageRoute = "/alerts";
export const AlertPageRoute = `${AlertsPageRoute}/alert/:alertId`;
export const AlertEditPageRoute = `${AlertPageRoute}/edit`;
export const AlertNewPageRoute = `${AlertsPageRoute}/new`;

// App Redirect
export const AppRedirectPageRoute = "/app";

// Other Pages
export const FAQSRoute = "/faqs";
export const ResetPasswordPageRoute = "/reset-password";
export const SendMessageRoute = "/send-message";
export const NotificationsPageRoute = "/notifications";
export const EntitySelectPageRoute = "/select-entity";
export const ActivateProfilePageRoute = "/activate-account";
export const ForgotPasswordPageRoute = "/forgot-password";

export const replaceRouteParams = (
  route: string,
  params: Record<string, string | number>,
): string => {
  let updatedRoute = route;
  Object.entries(params).forEach(([key, value]) => {
    updatedRoute = updatedRoute.replace(`:${key}`, String(value));
  });
  return updatedRoute;
};
